import './style.scss';
import type { ITariffZone } from '../../../../../../../../models/tariff-zone.model';
import { TranslationService } from '../../../../../../../../services/translation.service';
import { ITicketSuggestion } from '../../../../../../../../models/ticket-suggestion.model';
import { ZoneIconHelper } from './zoneIcon.helper';
import { IJourney } from '../../../../../../../../models/journey.model';

function ZoneIcon({ tariffZones, journey, className }: { tariffZones: ITariffZone[] | undefined; cheapestSingleTicket?: ITicketSuggestion; journey: IJourney; className?: string }) {
  const zoneIconText = ZoneIconHelper.getZoneIconText({ tariffZones, journey });
  if (!zoneIconText) return null;
  return <span className={`zone-icon bg-blue-800 fg-white rounded text-nowrap ${className ?? ''}`}>{`${TranslationService.get('common.tariffzone')} ${zoneIconText}`}</span>;
}

export default ZoneIcon;
